import { isValidOrigin } from "utils/isValidOrigin";
const env = globalThis._env;
export const getBffOrigin = (host: string) =>
  isValidOrigin(host) ? "https://" + host : env.REACT_APP_BFF_ORIGIN;
